<template>
  <div>
    <vxe-grid
      ref="table"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
      row-id="accountBookCode"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:orderNo="{ row }">
        <div>
          <el-link type="primary" @click="openOrderDetailPage(row.orderNo)">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  watch:{
    tableData(val){
      this.generateColumns(val)
    }
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      incomeColumnList: [],
      payColumnList: [],
    }
  },
  methods: {
    openOrderDetailPage(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: { no },
      })
    },
    getTableCheckedData(isNotEmpty) {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (isNotEmpty) {
        if (data === null || data === [] || data.length === 0) {
          this.$message({
            message: '请选择您要导出的订单！',
            type: 'warning',
          })
          return
        }
      }
      return data
    },
    batchExport() {
      const data = this.getTableCheckedData(true)
      if (!data) return
      let accountBookCodeList = []
      data.forEach((item) => {
        accountBookCodeList.push(item.accountBookCode)
      })
      let param = {
        accountBookCodeList: accountBookCodeList,
      }
      let url = '/finance/account/book/export'
      let fileName = '会计台账'
      this.$api.globalExportData(url, param, fileName)
    },
    //构建动态列
    generateColumns(data){
      //创建Set集合，存入费用类型
      const incomeTitleSet = new Set()
      const payTitleSet = new Set()
      //遍历所有行
      data.forEach((item) => {
        const map = JSON.parse(item.costDetail)
        const entry = Object.entries(map)
        entry.forEach((t) => {
          const key = t[0]
          const value = t[1]
          value.forEach((v) => {
            //判断是收入还是支出费用
            if (v.bookType === 'A') {
              //给属性名拼接后缀，用来区分收入和支出费用
              let filedName = key + 'A'
              incomeTitleSet.add(key)
              item[filedName] = v.feeAmount
            } else {
              let filedName = key + 'B'
              payTitleSet.add(key)
              item[filedName] = v.feeAmount
            }
          })
        })
      })
      //创建动态列的集合
      //应收费用动态列
      const incomeTitleList = Array.from(incomeTitleSet)
      const incomeColumnList = []
      incomeTitleList.forEach((item) => {
        incomeColumnList.push({
          field: item + 'A',
          title: item,
          showHeaderOverflow: true,
          showOverflow: true,
          width: 100,
        })
      })
      incomeColumnList.splice(0, 0, {
        field: 'incomeItem1',
        title: '运费',
        showHeaderOverflow: true,
        showOverflow: true,
        width: 100,
      })
      this.incomeColumnList = incomeColumnList
      //应付费用动态列
      const payTitleList = Array.from(payTitleSet)
      const payColumnList = []
      payTitleList.forEach((item) => {
        payColumnList.push({
          field: item + 'B',
          title: item,
          showHeaderOverflow: true,
          showOverflow: true,
          width: 100,
        })
      })
      payColumnList.splice(0, 0, {
        field: 'payItem1',
        title: '运费',
        showHeaderOverflow: true,
        showOverflow: true,
        width: 100,
      })
      this.payColumnList = payColumnList
      this.tableColumns = tableColumns(this)
    }
  },
}
</script>
